import React, { FC, InputHTMLAttributes, useId } from 'react';
import { IconProps } from '../Icon';
import * as SC from './styled';
import { ToggleButtonVariant } from './styled';
export type ToggleButtonProps = InputHTMLAttributes<HTMLInputElement> & {
  className?: string;
  label?: string;
  checked?: boolean;
  children?: React.ReactElement;
  iconBtn?: IconProps | any;
  subtitleBtn?: string | any;
  imageBtn?: string;
  variant?: ToggleButtonVariant;
  colorChecked?: string;
};
const ToggleButton: FC<ToggleButtonProps> = ({
  className,
  label,
  children,
  iconBtn,
  imageBtn,
  subtitleBtn,
  disabled,
  variant,
  colorChecked,
  ...checkbox
}) => {
  const uniqueId = useId();
  return <SC.Wrapper className={className} htmlFor={uniqueId} $checked={checkbox.checked} $disabled={disabled} $image={imageBtn ? true : false} $colorChecked={colorChecked} $variant={variant}
  //tabIndex={0}
  >
      <SC.Checkbox id={uniqueId} type={'checkbox'} disabled={disabled} {...checkbox} />
      {label && !imageBtn && <SC.Label $checked={checkbox.checked} $disabled={disabled}>
          <SC.LabelTitle $variant={variant} $icon={iconBtn ? true : false}>
            {iconBtn && <SC.StyledIcon $variant={variant} icon={iconBtn} width={24} height={24} />}
            <span>{label}</span>
          </SC.LabelTitle>
          {subtitleBtn && <SC.Subtitle>{subtitleBtn}</SC.Subtitle>}
        </SC.Label>}
      {imageBtn && <SC.StyledPicture images={[{
      src: imageBtn,
      size: 40
    }]} />}
      {children}
    </SC.Wrapper>;
};
export default ToggleButton;